import React from 'react';
import PropTypes from 'prop-types';
import StyledButton from '../common/StyledButton';
import Icon from 'SF/MaterialIcon';
import css from './Header.css';

const Header = props => {
  return (
    <header className={css['header']}>
      <h1>
        Add a link
      </h1>
      <h2>
        Use external links for links to content outside of Starfish. 
        Internal links are available for snippets and some templates and allow you to link 
        to Starfish content.
      </h2>
      <StyledButton 
        className={css['close-button']} 
        onClick={props.closeModal}
        aria-label="Close deep link modal"
        asLink>
        <Icon icon='close' />
      </StyledButton>
    </header>
  );
};

Header.propTypes = {
  closeModal: PropTypes.func.isRequired,
};


export default Header;
